angular.module('app.directives.schedule').directive('simulcastConfigurationEditor', () => {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
      verticalForm: '=',
    },
    template: require('./simulcast-configuration-editor.html'),
    controller: function ($scope, $filter, $timeout) {
      'ngInject';
      const { service } = $scope.vm;

      function renderSelectizeOption(wrapperCssClass, dateFilter) {
        return function (item, escape) {
          let html = `<div class="${wrapperCssClass}" style="vertical-align: middle;">`;
          html += `<div style="display: inline-flex; float: left; width: 32px; height: 32px; margin-right: 6px;">`;
          if (
            item.value.type == 'facebook' ||
            item.value.type == 'youtube' ||
            item.value.type == 'twitter'
          ) {
            html += `<span style="border-radius:0;width:32px;height:32px;" class="integration-badge integration-badge--${item.value.type}"></span>`;
          } else {
            html += `<span style="border-radius:0;width:32px;height:32px;" class="integration-badge integration-badge--rtmp_push">RTMP</span>`;
          }
          html += `</div>`;
          html += `<div class="overflow-ellipse" style="line-height:32px;">${item.name}</div></div>`;
          return html;
        };
      }

      const selectizeConfigBase = {
        valueField: 'valueJson',
        labelField: 'name',
        highlight: true,
        searchField: 'name',
        selectOnTab: true,
        closeAfterSelect: true,
        maxItems: 1,
        render: {
          option: renderSelectizeOption('source-chooser--option', $filter('date')),
          item: renderSelectizeOption('source-chooser--selected', $filter('date')),
        },
        onInitialize: (selectize) => {
          $scope.selectize = selectize;
        },
        onChange: (value) => {
          if (!value) return;
          value = JSON.parse(value);
          $timeout(() => {
            $scope.vm.addSimulcastDestination(value.type, value);
          }, 0);
          $scope.selectize.clear();
          $timeout(() => {
            $scope.selectedAccount = null;
          }, 500);
        },
      };
      $scope.selectizeConfig = angular.extend(
        { placeholder: 'Select Social Media and/or RTMP Destinations...' },
        selectizeConfigBase
      );

      $scope.selectedAccount = {};
      $scope.allAccounts = [];

      service.destinationPromise.then(() => {
        if (service.allowFacebookLive) {
          // FIXME: consider listing all fb accounts here?
          $scope.allAccounts.push({ name: 'Facebook', value: { type: 'facebook' } });
        }
        if (service.allowYoutubeLive) {
          if (service.youtubeUsers.length) {
            service.youtubeUsers.forEach((u) => {
              $scope.allAccounts.push({
                name: `YouTube: ${u.display_name}`,
                value: { type: 'youtube', id: u.id },
              });
            });
          } else {
            $scope.allAccounts.push({
              name: 'YouTube',
              value: { type: 'youtube', isHelpRow: true },
            });
          }
        }
        if (service.allowTwitter) {
          if (service.twitterUsers.length) {
            service.twitterUsers.forEach((u) => {
              $scope.allAccounts.push({
                name: `Twitter: ${u.display_name}`,
                value: { type: 'twitter', id: u.id },
              });
            });
          } else {
            $scope.allAccounts.push({
              name: 'Twitter',
              value: { type: 'twitter', isHelpRow: true },
            });
          }
        }
        if (service.allowGenericRtmpPush && service.rtmpPushChannels.length) {
          service.rtmpPushChannels.forEach((u) => {
            $scope.allAccounts.push({
              name: `Other RTMP: ${u.name}`,
              value: { type: 'rtmp_push_channel', id: u.id },
            });
          });
        }
        if (service.allowGenericRtmpPush) {
          $scope.allAccounts.push({ name: 'Other RTMP (Single-Use)', value: { type: 'generic' } });
        }
        $scope.allAccounts.forEach((a) => {
          a.valueJson = JSON.stringify(a.value);
        });
      });
    },
  };
});



// WEBPACK FOOTER //
// ./app/directives/schedule/simulcast-configuration-editor.js